<!-- 首页行业展会列表：图片 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="'/hyzx/zhDetails/'+info.id" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}" target="_blank">

  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock08',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number|String,
      default:10
    },
    labelLength:{
      type:Number|String,
      default:28
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:160px;
  width:100%;
  padding:0px 10px 0px 10px;
  margin-top:10px;
  border:0px solid #fff;
  background-color: #eee;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:0px solid #eee;
  color:var(--color6);
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  display:block;
  font-size:16px;
  font-weight:500;
  color:#282A2B;
  line-height:30px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.info-block-a .label{
  display:block;
  padding-top:6px;
  font-size:12px;
  color:#9FA2A6;
  line-height:20px;
  color:#888;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock10.vue